import React from 'react'

import { Box, Button, Container, TextField } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { Link } from 'react-router-dom'

import api from 'common/api'

class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user: '',
      password: '',
    }
  }

  componentDidMount() {
    document.title = 'Scoir - login'
  }

  handleChange(name, val) {
    this.setState({
      [name]: val,
    })
  }

  login(e) {
    e.preventDefault()
    e.stopPropagation()

    this.setState({
      error: false,
    })
    return api
      .post('/api/login', {
        UserName: this.state.user,
        Password: this.state.password,
      })
      .then((result) => {
        document.cookie = `bearer=${result.access_token}; path=${import.meta.env.BASE_URL}`
        this.setState({
          isLoggedIn: true,
        })
      })
      .catch(() => {
        this.setState({
          error: true,
          isLoggedIn: false,
        })
      })
  }

  render() {
    return (
      <form>
        <Container>
          <Box
            margin="40px auto"
            maxWidth="400px"
          >
            <Box>
              <TextField
                value={this.state.user}
                label="username"
                onChange={(e) => this.handleChange('user', e.target.value)}
                variant="outlined"
                color="primary"
                fullWidth
                margin="normal"
              />
              <TextField
                type="password"
                value={this.state.password}
                label="password"
                onChange={(e) => this.handleChange('password', e.target.value)}
                variant="outlined"
                color="primary"
                fullWidth
                margin="normal"
              />
              <Box
                my={2}
                textAlign="center"
              >
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  onClick={(e) => this.login(e)}
                >
                  Login
                </Button>
              </Box>
            </Box>
            <Box>
              {this.state.error ? <Alert severity="error">An error occurred during login</Alert> : null}
              {this.state.isLoggedIn ? (
                <Alert severity="success">
                  <Link to="/admissions/home">User is logged in Yay!</Link>
                </Alert>
              ) : null}
            </Box>
          </Box>
        </Container>
      </form>
    )
  }
}

export default Login
